/*
 * Copyright (c) 2021-2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: mutations.gql.ts
 * Project: mle-client
 * Committed last: 2021/11/12 @ 847
 * ---
 */

import {gql} from '@apollo/client';

/**
 * Crea nuova etichetta a partire da MpesDocument serializzato.
 * Chiede in risposta i campi principali dell'entità.
 * @type {DocumentNode}
 */
export const CREATE_LABEL = gql`
    mutation($bodyContent: String!, $title: String!) {
        addLabel(bodyContent: $bodyContent, title: $title) {
            id
            title
            creationDate
            bodyContent
        }
    }
`;

/**
 * Aggiorna etichetta a partire da MpesDocument serializzato.
 * Chiede in risposta i campi principali dell'entità.
 * @type {DocumentNode}
 */
export const UPDATE_LABEL = gql`
    mutation($id: Int!, $bodyContent: String!, $title: String!) {
        updateLabel(id: $id, bodyContent: $bodyContent, title: $title) {
            id
            title
            creationDate
            bodyContent
        }
    }
`;

/**
 * Elimina definitivamente etichetta e MpesDocument associato.
 * Chiede in risposta l'identificativo appena rimosso, per consentire eventuali
 * aggiornamenti di stato nel client.
 * @type {DocumentNode}
 */
export const REMOVE_LABEL = gql`
    mutation($id: Int!) {
        removeLabel(id: $id) {
            id
        }
    }
`;

/**
 * Crea una nuova azienda.
 * Chiede in risposta i campi principali dell'entità.
 * @type {DocumentNode}
 */
export const CREATE_COMPANY = gql`
    mutation($input: CompanyInput!) {
        addCompany(input: $input) {
            id
            name
            taxCode
            fiscalCode
            reaCode
            pec
            email
            address
        }
    }
`;

/**
 * Controlla se un titolo è disponibile o è già utilizzato da un'altra etichetta
 */
export const TITLE_AVAILABLE = gql`
    mutation ($title: String!) {
        titleAvailable(title: $title)
    }
`;

/**
 * Crea un utente.
 * Chiede in risposta i campi principali dell'entità.
 * Non contiene le credenziali di accesso nè l'email, che sono invece gestiti
 * dall'AuthProvider (REST) con l'entità AuthEntity.
 * @type {DocumentNode}
 */
export const CREATE_USER = gql`
    mutation($input: UserInput!) {
        addUser(input: $input) {
            id
            firstName
            lastName
            phone
            company {
                id
                name
                taxCode
                fiscalCode
                reaCode
                pec
                email
                address
            }
        }
    }
`;

/**
 * Effettua l'upload di un'immagine
 */
export const UPLOAD_IMAGE = gql`
    mutation ($file: Upload!) {
        uploadImage(image: $file) {
            filename
        }
    }
`;

export const DELETE_IMAGE_BY_ID = gql`
    mutation ($id: Int!) {
        removeImage(id: $id) {
            id
        }
    }
`;

/**
 * Risolve le origini dati presenti nel documento
 */
export const RESOLVE_DATAORIGINS = gql`
    mutation ($id: Int!, $activeRecipe: Int, $activeCompanyId: Int, $vars: String) {
        exportLabel(id: $id, vars: $vars, activeRecipeId: $activeRecipe, activeCompanyId: $activeCompanyId)
    }
`;

/**
 * Effettua il login a MyLabel
 */
export const ML_LOGIN = gql`
    mutation ($username: String!, $password: String!) {
        mle_login(password: $password, username: $username)
    }
`;

export const CREATE_DATAORIGIN = gql`
    mutation ($input: DataOriginInput!) {
        addDataOrigin(input: $input) {
            id
            name
        }
    }
`;

export const REMOVE_DATAORIGIN = gql`
    mutation($id: Int!) {
        removeDataOrigin(id: $id)
    }
`;
